import currency from "currency.js";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import useIndexWSS from "../../../hooks/wss/useIndexWSS";
import Stat from "../Stat";
import { useMarkPriceWSS } from "../../../hooks/wss/useMarkPriceWSS";
import { IPerpsMarket } from "../../../contexts/MarketInstrumentContext/useGetMarkets";
import { InstrumentTypeResponse } from "../../../codegen-api";

interface IIndexPriceStatProps {
  openInterestContracts: number;
  perpInstrument?: IPerpsMarket;
}

function OpenInterestStat({
  openInterestContracts,
  perpInstrument,
}: IIndexPriceStatProps) {
  const { t } = useTranslation("app", {
    keyPrefix: "TradingHeader.PerpsTradingHeader",
  });

  const { index } = useIndexWSS(perpInstrument?.underlying_asset);
  const m = useMarkPriceWSS(
    perpInstrument
      ? {
          instrumentName: perpInstrument.instrument_name,
          asset: perpInstrument.underlying_asset,
          derivative: InstrumentTypeResponse.Perpetual,
        }
      : undefined
  );
  const markPrice = m?.mark_price || perpInstrument?.mark_price;

  const openInterest = useMemo(() => {
    const priceToUse = perpInstrument?.pre_launch ? markPrice : index?.price;
    return priceToUse ? openInterestContracts * Number(priceToUse) : undefined;
  }, [
    index?.price,
    markPrice,
    openInterestContracts,
    perpInstrument?.pre_launch,
  ]);

  return (
    <Stat
      label={t("open_interest")}
      value={openInterest ? currency(openInterest).format() : "-"}
    />
  );
}

export default OpenInterestStat;
